export const getSouscriptionGaranties = state => state.souscription.garanties && state.souscription.garanties.data
export const isSouscriptionGarantiesLoading = state => state.souscription.garanties && state.souscription.garanties.loading
export const getSouscriptionGarantiesExpirationDate = state => state.souscription.garanties && state.souscription.garanties.expirationDate
